import {
  SET_BREADCRUMBS,
  SET_SEARCH,
  SET_SEARCH_RESULTS,
  SET_FACETS,
  SET_APPLIED_REFINEMENTS,
  SET_TITLE,
  SET_PAGE_META_DATA,
  TOGGLE_FILTER_MENU,
  OPEN_FILTERS,
  CLOSE_FILTERS,
} from './_types';

export default {
  [SET_BREADCRUMBS]: (state, breadcrumbs) => {
    state.breadcrumbsArr = breadcrumbs;
  },
  [SET_SEARCH]: (state, search) => {
    state.searchObj = search;
  },
  [SET_SEARCH_RESULTS]: (state, searchResults) => {
    state.searchResults = searchResults;
  },
  [SET_FACETS]: (state, facets) => {
    state.facets = facets;
  },
  [SET_APPLIED_REFINEMENTS]: (state, appliedRefinements) => {
    state.appliedRefinements = appliedRefinements;
  },
  [SET_TITLE]: (state, title) => {
    state.pageTitle = title;
  },
  [SET_PAGE_META_DATA]: (state, pageMetaData) => {
    state.pageMetaData = pageMetaData;
  },
  [TOGGLE_FILTER_MENU]: ({ toggledFilterMenus }, name) => {
    const isToggled = toggledFilterMenus.includes(name);
    if (isToggled) {
      toggledFilterMenus.splice(toggledFilterMenus.indexOf(name), 1);
    } else {
      toggledFilterMenus.push(name);
    }
  },
  [OPEN_FILTERS]: (state) => {
    state.filterModalOpened = true;
  },
  [CLOSE_FILTERS]: (state) => {
    state.filterModalOpened = false;
  },
};
